export default ['AppReducer',"cookiesReducer"];
